// extracted by mini-css-extract-plugin
export var button = "bE8Yd";
export var buttons = "XTTYu";
export var centered = "QhwLb";
export var checkNetworkConnection = "nf8fk";
export var errorReport = "KdSTz";
export var newPadding = "HJ_S3";